import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AnatomyAssistantPirogovDev from "./pages/AI-Pirogov-dev";
import AnatomyAssistantPirogovSimple from "./pages/AI-Pirogov-simple";
import AnatomyAssistantAnatomageSimple from "./pages/AI-Anatomage-simple";
import ClinicalCasesSearch from "./pages/Clinical-cases-Anatomage";
import AnatomageHome from './pages/Anatomage-home';
import AIbrainHome from './pages/AI-Brain-home';
import AdminTokenManager from './pages/AdminTokenManager';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AIbrainHome />} />
        <Route path="/anatomage/" element={<AnatomageHome />} />
        <Route path="/anatomage/presets-creator/" element={<AnatomyAssistantAnatomageSimple />} />
        <Route path="/anatomage/clinical-cases/" element={<ClinicalCasesSearch />} />
        <Route path="/pirogov/presets-creator/" element={<AnatomyAssistantPirogovSimple />} />
        <Route path="/pirogov/presets-creator/dev/" element={<AnatomyAssistantPirogovDev />} />
        <Route path="/api-tokens-management/" element={<AdminTokenManager />} />
      </Routes>
    </Router>
  );
}

export default App;
